import type {
  AmendmentDraft,
  AmendmentDraftInput,
  AmendmentOptions,
} from "../../services/amendment.service";

export interface AmendmentFormValues {
  reason: string;
  contentHtml: string;
  sourceMacroId: string | null;
}

export interface AmendmentEditorFormModalProps {
  opened: boolean;
  caseId: string;
  caseNumber: string;
  sessionId?: string | null;
  initialDraft: AmendmentDraft | null;
  options: AmendmentOptions;
  onClose: () => void;
  onSigned: () => void;
  onSessionUpdated?: (sessionId: string, expiresAt?: string) => void;
  reviewRequired: boolean;
}

export function buildInitialAmendmentValues(
  draft: AmendmentDraft | null
): AmendmentFormValues {
  return {
    reason: draft?.reason || "",
    contentHtml: draft?.contentHtml || "",
    sourceMacroId: draft?.sourceMacroId || null,
  };
}

export function buildAmendmentDraftInput(
  values: AmendmentFormValues,
  revision?: number
): AmendmentDraftInput {
  return {
    ...values,
    reason: values.contentHtml
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim(),
    revision,
  };
}
